import {
  Component,
  ViewEncapsulation
} from '@angular/core';



export class MdlLayoutHeaderRowComponent {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-layout-header-row',
  host: {
    '[class.mdl-layout__header-row]': 'true'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
